module.exports = __webpack_public_path__ + "img/arrow-change.1c5da8a1.svg";